module.exports = __webpack_public_path__ + "static/the-vision-of-the-anointed-196383131452f5c0122dec2b7b23de5c.jpg";